<template>
  <div class="not-found">
    <div class="logo-container">
      <img src="@/assets/logo-herder.png" alt="Logo" class="logo" />
    </div>
    <h1 class="error-title">404 - Seite nicht gefunden</h1>
    <p class="error-message">
      Oh nein! Wir können die Seite, die du suchst, nicht finden. Vielleicht hast du dich verirrt?
    </p>
    <div class="animation-container">
      <div class="magnifying-glass">
        🔍
      </div>
    </div>
    <button @click="goHome" class="home-button">Zurück zur Startseite</button>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { useMeta } from 'vue-meta';

export default {
  name: 'not-found',
  setup() {
    const { t } = useI18n();
    useMeta({
      title: t('page-not-found'),
    });
  },
  props: {
    context: {
      type: Object,
    },
  },
  methods: {
    goHome() {
      // Navigation zur Startseite
      this.$router.push("/puettchen2/");
    },
  },
};
</script>

<style scoped>
.not-found {
  text-align: center;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f9f9f9;
}

.logo-container {
  position: absolute;
  top: 50px;
  text-align: center;
}

.logo {
  width: 240px;
  height: auto;
}

.error-title {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 10px;
}

.error-message {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 30px;
}

.animation-container {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 20px auto;
}

.magnifying-glass {
  font-size: 3rem;
  animation: wobble 2s infinite;
}

@keyframes wobble {
  0%, 100% {
    transform: rotate(0deg) translateX(0);
  }
  25% {
    transform: rotate(15deg) translateX(10px);
  }
  50% {
    transform: rotate(-15deg) translateX(-10px);
  }
  75% {
    transform: rotate(15deg) translateX(5px);
  }
}

.home-button {
  background-color: #db3434;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 5px;
  text-transform: uppercase;
  transition: background-color 0.3s;
}

.home-button:hover {
  background-color: #2980b9;
}
</style>